import * as CookieConsent from 'vanilla-cookieconsent';

import 'vanilla-cookieconsent/dist/cookieconsent.css';

CookieConsent.run({
    revision: 1,
    categories: {
        necessary: {
            enabled: true,
            readOnly: true,
        },
        analytics: {
            enabled: true,
        },
        targeting: {
            enabled: true,
        },
    },
    cookie: {
        expiresAfterDays: (acceptType) => {
            return acceptType === 'all' ? 365.25 : 1;
        },
    },
    guiOptions: {
        consentModal: {
            acceptAllBtn: 'test',
            layout: 'cloud',
            position: 'bottom center',
            flipButtons: false,
            equalWeightButtons: false,
            showPreferencesBtn: true,
        },
        preferencesModal: {
            layout: 'cloud',
            position: 'center',
            equalWeightButtons: false,
            flipButtons: true,
        },
    },
    onConsent: ({ cookie }) => {
        if (typeof fbq == 'function') {
            if (cookie.categories.includes('analytics')) {
                fbq('consent', 'grant');
            } else {
                fbq('consent', 'revoke');
            }
        }

        if (typeof gtag == 'function') {
            if (cookie.categories.includes('analytics')) {
                gtag('consent', 'update', {
                    analytics_storage: 'granted',
                });
            } else {
                gtag('consent', 'update', {
                    analytics_storage: 'denied',
                });
            }
            if (cookie.categories.includes('targeting')) {
                gtag('consent', 'update', {
                    ad_storage: 'granted',
                });
                gtag('consent', 'update', {
                    ad_user_data: 'granted',
                });
                gtag('consent', 'update', {
                    ad_personalization: 'granted',
                });
            } else {
                gtag('consent', 'update', {
                    ad_storage: 'denied',
                });
                gtag('consent', 'update', {
                    ad_user_data: 'denied',
                });
                gtag('consent', 'update', {
                    ad_personalization: 'denied',
                });
            }
        }
    },

    onChange: ({ cookie, changedCategories, changedServices }) => {
        if (typeof fbq == 'function') {
            if (cookie.categories.includes('analytics')) {
                fbq('consent', 'grant');
            } else {
                fbq('consent', 'revoke');
            }
        }

        if (typeof gtag == 'function') {
            if (cookie.categories.includes('analytics')) {
                gtag('consent', 'update', {
                    analytics_storage: 'granted',
                });
            } else {
                gtag('consent', 'update', {
                    analytics_storage: 'denied',
                });
            }
            if (cookie.categories.includes('targeting')) {
                gtag('consent', 'update', {
                    ad_storage: 'granted',
                });
                gtag('consent', 'update', {
                    ad_user_data: 'granted',
                });
                gtag('consent', 'update', {
                    ad_personalization: 'granted',
                });
            } else {
                gtag('consent', 'update', {
                    ad_storage: 'denied',
                });
                gtag('consent', 'update', {
                    ad_user_data: 'denied',
                });
                gtag('consent', 'update', {
                    ad_personalization: 'denied',
                });
            }
        }
    },

    language: {
        default: 'fr',
        translations: {
            fr: {
                consentModal: {
                    title: 'Nous respectons vos données.',
                    description:
                        'Nous utilisons des cookies sur ce site pour améliorer votre expérience utilisateur et nos opérations marketing. Consulter notre <a href="/politique-de-confidentialite" target="_blank">politique de confidentialité</a>.',
                    acceptAllBtn: 'Accepter',
                    showPreferencesBtn: 'Gérer les préférences',
                },
                preferencesModal: {
                    title: 'Préférence des cookies',
                    acceptAllBtn: 'Accepter',
                    acceptNecessaryBtn: 'Refuser',
                    savePreferencesBtn: 'Enregistrer mes préférences',
                    closeIconLabel: 'Fermer',
                    sections: [
                        {
                            title: 'Protection des données',
                            description:
                                'Nous utilisons vos données afin de vous proposer du contenu et des publicités personnalisés. Nous analysons la diffusion de ces contenus et publicités afin d’obtenir des informations sur l’utilisation de notre site Web. Ces données peuvent être partagées avec nos partenaires, sur la base de votre consentement ou de notre intérêt légitime. ',
                        },
                        {
                            title: 'Cookies strictement nécessaires',
                            description:
                                'Ces cookies sont nécessaires au fonctionnement du site Web et ne peuvent pas être désactivés dans nos systèmes.',
                            linkedCategory: 'necessary',
                        },
                        {
                            title: 'Cookies de performance',
                            description:
                                "Ces cookies nous permettent de déterminer le nombre de visites et les sources du trafic, afin de mesurer et d’améliorer les performances de notre site Web. Ils nous aident également à identifier les pages les plus / moins visitées et d’évaluer comment les visiteurs naviguent sur le site Web. Toutes les informations collectées par ces cookies sont agrégées et donc anonymisées. Si vous n'acceptez pas ces cookies, nous ne serons pas informé de votre visite sur notre site.",
                            linkedCategory: 'analytics',
                        },
                        {
                            title: 'Cookies pour une publicité ciblée',
                            description:
                                "Ces cookies peuvent être mis en place au sein de notre site Web par nos partenaires publicitaires. Ils peuvent être utilisés par ces sociétés pour établir un profil de vos intérêts et vous proposer des publicités pertinentes sur d'autres sites Web. Ils ne stockent pas directement des données personnelles, mais sont basés sur l'identification unique de votre navigateur et de votre appareil Internet. Si vous n'autorisez pas ces cookies, votre publicité sera moins ciblée.",
                            linkedCategory: 'targeting',
                        },
                        {
                            description:
                                "En cas de question sur notre <a target='_blank' href='/politique-de-confidentialite'>politique de confidentialité<a>, <a href='/#contact'>contactez-nous</a>.",
                        },
                    ],
                },
            },
        },
    },
});
